<template>
  <div class="pilatus page-component">
    <div class="container">
      <div class="pilatus__image-wrapper">
        <img src="/images/pilatus.jpg" alt="Pilatus"/>
        <div class="pilatus__text-container view-observed" v-view>
          <h2 class="pilatus__title">{{ fields.title }}</h2>
          <p class="pilatus__description lead-text">{{ $prismic.richTextAsPlain(fields.text) }}</p>
          <a v-for="link in fields.links" 
             :key="link.href"
             :href="link.href"
             class="btn btn-primary"
             target="_blank">
            {{ link.text1 }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'Pilatus',
  data () {
    return {
      fields: {
        title: null,
        text: null,
        links: null
      }
    }
  },
  methods: {
    async getContent (language) {
      let document = 	await this.$prismic.client.getByUID('pagedescription', 'the-pilatus', { lang : language })
      if (document) {
        this.fields.title = document.data.title[0].text
        this.fields.text = document.data.text
        this.fields.links = document.data.links
      }
    }
  },
  async created () {
    await this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
}
</script>